import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import ReactLoading from 'react-loading';
import { LazyImage, LazyImageStyles } from './LazyImage';

function calcDuration(dep, arr) {
    try {
        var [dh, dm] = dep.split('.').map(Number);
        var [ah, am] = arr.split('.').map(Number);
        var diff = (ah*60 + (am||0)) - (dh*60 + (dm||0));
        if (diff < 0) diff += 24*60;
        var hrs = Math.floor(diff/60), mins = diff%60;
        return hrs + '.' + (mins<10?'0':'') + mins + ' ชม.';
    } catch { return ''; }
}

export function ProgramPlusCardStyles() {
    return (
        <>
            <LazyImageStyles />
            <style>{`
                .pp-list-card.h-100 img { height: auto !important; width: auto !important; }
                .pp-list-card.h-100 img.pp-cover { height: 240px !important; width: 100% !important; object-fit: cover !important; }
                .pp-list-card.h-100 img.pp-sm-img { height: 100% !important; width: 100% !important; object-fit: cover !important; }
                .pp-list-card.h-100 img.pp-airline-logo { height: 18px !important; width: auto !important; max-width: 100% !important; object-fit: contain !important; }
            `}</style>
        </>
    );
}

export function ProgramPlusCard({ p, linkTo, showActions, onDelete, loading }) {
    if (loading) {
        return (
            <div className="card h-100 pp-list-card" style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', background: '#fff', border: 'none', minHeight: 420 }}>
                <div style={{ background: '#eee', height: 240, width: '100%' }}></div>
                <div className="d-flex align-items-center justify-content-center" style={{ flex: 1, padding: 20 }}>
                    <ReactLoading type={'cylon'} color={'#e1e5eb'} height={60} width={60} />
                </div>
            </div>
        );
    }
    var flights = p.flights || [];
    var periods = p.periods || [];
    var inner = (
        <div className="card h-100 pp-list-card" style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', transition: 'transform 0.2s', background: '#fff', border: 'none' }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
            <div style={{ position: 'relative' }}>
                {p.coverImg ? (
                    <LazyImage src={p.coverImg} alt="" className="pp-cover"
                        containerStyle={{ width: '100%', height: 240 }}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                ) : (
                    <div className="pp-cover" style={{ width: '100%', height: 240, background: 'linear-gradient(135deg,#f8c7c1 0%, #f0a0a0 50%, #dc3545 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
                        <i className="fas fa-image" style={{ fontSize: 64, opacity: 0.55 }}></i>
                    </div>
                )}
                <span style={{ position: 'absolute', bottom: 8, right: 8, background: 'rgba(0,0,0,0.6)', color: '#fff', padding: '2px 8px', borderRadius: 20, fontSize: 11 }}>{p.days}D{p.nights}N</span>

                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, padding: '10px 14px', background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 60%, rgba(255,255,255,0) 100%)' }}>
                    <div className="d-flex align-items-start" style={{ gap: 8 }}>
                        <div style={{ background: '#2c2c2c', color: '#fff', padding: '4px 8px', borderRadius: 3, fontWeight: 800, fontSize: 11, flexShrink: 0, lineHeight: 1 }}>{p.code}</div>
                        <div style={{ minWidth: 0, flex: 1 }}>
                            <div style={{ color: '#dc3545', fontWeight: 900, fontSize: 15, lineHeight: 1.15, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{p.name}</div>
                            {p.destinations && (
                                <div style={{ marginTop: 4, fontSize: 11, color: '#333', fontWeight: 500, display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                    <i className="fas fa-map-marker-alt" style={{ color: '#dc3545', marginRight: 4 }}></i>
                                    {p.destinations}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ position: 'relative', marginTop: -40, padding: '0 8px 8px 8px' }}>
                <div className="row g-2 align-items-stretch">
                    <div className="col-7">
                        <div className="d-flex flex-column" style={{ gap: 4, height: '100%' }}>
                            <div className="row g-1">
                                {[p.coverSm1, p.coverSm2].map((img,i)=>(
                                    <div key={i} className="col-6">
                                        <div style={{ width:'100%', height:70, borderRadius:4, overflow:'hidden', boxShadow:'0 2px 6px rgba(0,0,0,0.2)' }}>
                                            {img ? (
                                                <LazyImage src={img} alt="" className="pp-sm-img"
                                                    containerStyle={{ width:'100%', height:'100%' }}
                                                    style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                                            ) : (
                                                <div style={{ width:'100%', height:'100%', background:'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', border:'1px dashed #ddd', display:'flex', alignItems:'center', justifyContent:'center', color:'#ccc' }}>
                                                    <i className="fas fa-image" style={{ fontSize:22 }}></i>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {flights.length === 0 ? (
                                <div style={{ flex:1, minHeight:70, background:'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', borderRadius:12, border:'2px dashed #ddd', display:'flex', alignItems:'center', justifyContent:'center', color:'#bbb', boxShadow:'0 2px 6px rgba(0,0,0,0.04)' }}>
                                    <i className="fas fa-plane" style={{ fontSize:26 }}></i>
                                </div>
                            ) : (
                                <div style={{ flex:1, background:'#fff', borderRadius:12, padding:'4px 6px 6px', border:'2px solid #f0a0a0', boxShadow:'0 2px 6px rgba(0,0,0,0.08)' }}>
                                    <div className="d-flex align-items-center justify-content-center mb-1" style={{ gap:4 }}>
                                        {p.airlineLogo ? (
                                            <img src={p.airlineLogo} alt="" className="pp-airline-logo" style={{ objectFit:'contain' }} />
                                        ) : p.airlineName ? (
                                            <div style={{ background:'#c8102e', color:'#fff', borderRadius:'50%', width:18, height:18, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:900, fontSize:10 }}>{p.airlineName.charAt(0)}</div>
                                        ) : (
                                            <div style={{ width:22, height:18, border:'1px dashed #ccc', borderRadius:4, display:'flex', alignItems:'center', justifyContent:'center', color:'#bbb' }}>
                                                <i className="fas fa-plane" style={{ fontSize:10 }}></i>
                                            </div>
                                        )}
                                        {p.airlineName && (
                                            <div style={{ fontSize:7, fontWeight:900, color:'#222', lineHeight:1, fontStyle:'italic', textTransform:'uppercase' }}>
                                                {p.airlineName.split(' ').map((w,i)=><div key={i}>{w}</div>)}
                                            </div>
                                        )}
                                    </div>
                                    <div className="d-flex" style={{ gap:0 }}>
                                        {flights.slice(0,2).map((f,i)=>{
                                            var dur = calcDuration(f.departTime, f.arriveTime);
                                            return (
                                                <React.Fragment key={i}>
                                                    {i > 0 && <div style={{ width:1, background:'#dc3545', margin:'0 3px' }}></div>}
                                                    <div style={{ flex:1, padding:'0 2px' }}>
                                                        <div className="d-flex justify-content-between align-items-center" style={{ fontSize:7, color:'#666', marginBottom:1 }}>
                                                            <span style={{ fontWeight:600 }}>{f.flightNo}</span>
                                                            <i className="fas fa-plane" style={{ color:'#c8102e', fontSize:7 }}></i>
                                                            <span style={{ fontWeight:600 }}>{f.arriveTime}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div style={{ textAlign:'center', minWidth:26 }}>
                                                                <div style={{ fontWeight:900, fontSize:12, lineHeight:1, color:'#222', letterSpacing:0.5 }}>{f.routeFrom.split(' ')[0]}</div>
                                                            </div>
                                                            <div style={{ flex:1, textAlign:'center', paddingTop:4 }}>
                                                                <div style={{ fontSize:6, color:'#666', lineHeight:1 }}>{dur}</div>
                                                                <div style={{ height:1, background:'#999', margin:'2px 2px 0' }}></div>
                                                            </div>
                                                            <div style={{ textAlign:'center', minWidth:26 }}>
                                                                <div style={{ fontWeight:900, fontSize:12, lineHeight:1, color:'#222', letterSpacing:0.5 }}>{f.routeTo.split(' ')[0]}</div>
                                                            </div>
                                                        </div>
                                                        <div style={{ textAlign:'center', fontSize:8, color:'#222', marginTop:1, fontWeight:700, textDecoration:'underline', textUnderlineOffset:2 }}>
                                                            {f.direction === 'outbound' ? 'ขาไป' : 'ขากลับ'}
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-5">
                        <div className="d-flex flex-column" style={{ gap: 4, height: '100%' }}>
                            <div style={{ background:'#fff', borderRadius:8, padding:'4px 6px', border:'2px solid #dc3545', flex:1, boxShadow:'0 2px 6px rgba(0,0,0,0.08)' }}>
                                <div style={{ fontSize:13, color:'#666', textAlign:'center', marginBottom:4, fontWeight:600 }}>กำหนดการเดินทาง</div>
                                {periods.length > 0 ? periods.slice(0,3).map((pd,i)=>(
                                    <div key={i} style={{ fontSize:10, fontWeight:800, color:'#dc3545', textAlign:'center', lineHeight:1.2, padding:'1px 0', borderTop: i>0?'1px dashed #eee':'none' }}>
                                        {dayjs(pd.startDate).format('DD')} - {dayjs(pd.endDate).format('DD MMM')} {parseInt(dayjs(pd.endDate).format('YYYY'))+543}
                                    </div>
                                )) : <div style={{ fontSize:9, color:'#ccc', textAlign:'center' }}>-</div>}
                            </div>
                            <div style={{ background:'#fff', borderRadius:8, padding:'4px 6px', border:'2px dashed #dc3545', textAlign:'center', boxShadow:'0 2px 6px rgba(0,0,0,0.08)' }}>
                                <div style={{ fontSize:13, color:'#666', fontWeight:600 }}>เริ่มต้น</div>
                                <div style={{ fontSize:18, fontWeight:800, color:'#dc3545', lineHeight:1 }}>
                                    {p.startPrice > 0 ? Number(p.startPrice).toLocaleString() + '.-' : '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showActions && (
                <div className="card-footer d-flex justify-content-between p-2" style={{ background: '#fafafa', gap: 4 }}>
                    <Link to={'/console/programplus/view/' + p.id} className="btn btn-outline-success btn-sm" style={{ fontSize: 12 }}>
                        <i className="fas fa-eye"></i> ดู
                    </Link>
                    <Link to={'/console/programplus/edit/' + p.id} className="btn btn-outline-primary btn-sm" style={{ fontSize: 12 }}>
                        <i className="fas fa-edit"></i> แก้ไข
                    </Link>
                    <button className="btn btn-outline-danger btn-sm" style={{ fontSize: 12 }} onClick={() => onDelete && onDelete(p)}>
                        <i className="fas fa-trash"></i> ลบ
                    </button>
                </div>
            )}
        </div>
    );

    return linkTo ? <Link to={linkTo} style={{ textDecoration:'none', color:'inherit', display:'block', height:'100%' }}>{inner}</Link> : inner;
}
